import { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { FieldError } from '../../../../../components/novarium/NvTableParts';
import { OrderRow, SelectOption } from '../../../types/billing.types';

interface ProfessionalsDialogProps {
  row: OrderRow;
  options: SelectOption[];
  onCancel: () => void;
  onSave: (professionalIds: number[]) => void;
}

/** "Cambiar profesionales" de una práctica: se vuelve a valorizar con ellos, como en Vaadin. */
export default function ProfessionalsDialog({ row, options, onCancel, onSave }: ProfessionalsDialogProps) {
  const [selected, setSelected] = useState<number[]>(row.professionals.map((p) => p.id));
  const [error, setError] = useState<string | undefined>();
  // Los de la fila pueden no estar en la lista de activos (por ejemplo, los de la agenda): se agregan para mostrarlos
  const allOptions = [...options, ...row.professionals.filter((p) => !options.some((o) => o.id === p.id))];

  const save = () => {
    if (selected.length === 0) {
      setError('Elegí al menos un profesional');
      return;
    }
    onSave(selected);
  };

  return (
    <Dialog
      header="Cambiar profesionales"
      visible
      onHide={onCancel}
      className="nv-scope nv-dialog nv-dialog-s"
      modal
      draggable={false}
      footer={(
        <>
          <Button type="button" className="buttonMain2" outlined label="Cancelar" onClick={onCancel} />
          <Button type="button" className="buttonMain" label="Guardar cambios" onClick={save} />
        </>
      )}
    >
      <div className="nv-dialog-body">
        <p className="nv-help">{[row.code, row.description].filter(Boolean).join(' - ')}</p>
        <div className="nv-field">
          <label htmlFor="row-professionals">Profesionales <span className="nv-req">*</span></label>
          <MultiSelect panelClassName="nv-scope"
            inputId="row-professionals"
            value={selected}
            options={allOptions}
            optionLabel="name"
            optionValue="id"
            display="chip"
            filter
            placeholder="Seleccionar"
            onChange={(e) => { setSelected(e.value ?? []); setError(undefined); }}
            className={error ? 'p-invalid' : undefined}
          />
          <FieldError id="row-professionals-error" message={error} />
        </div>
      </div>
    </Dialog>
  );
}
